import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectVillage } from '../../../../selectors/village';
import { useApplicationContext } from '../../../../utils/applicationContext';

export const useMapPreviewUrl = () => {
  const { config } = useApplicationContext();
  const { coordinates, id } = useSelector(selectVillage);

  return useMemo(() => {
    const mapPreviewTemplate = config.get<string>('audience.mapPreviewTemplate');

    if (!mapPreviewTemplate) {
      return '';
    }

    const params: Record<string, number> = { ...coordinates, id };

    return mapPreviewTemplate.replace(/{{(lat|lng|id)}}/g, (_, matched) => `${params[matched]}`);
  }, [config, coordinates, id]);
};
